(function(){
  var roots = document.querySelectorAll('[data-nf-home-showroom]');
  if(!roots.length) return;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function clamp(value, min, max){
    return Math.max(min, Math.min(max, value));
  }

  function animateNumber(el){
    if(el.dataset.nfCountDone === 'true') return;
    el.dataset.nfCountDone = 'true';
    var target = parseFloat(el.getAttribute('data-nf-count-to') || '0');
    var decimals = parseInt(el.getAttribute('data-nf-count-decimals') || '0', 10);
    var suffix = el.getAttribute('data-nf-count-suffix') || '';
    if(reduceMotion || !window.requestAnimationFrame){
      el.textContent = target.toFixed(decimals) + suffix;
      return;
    }
    var start = null;
    var duration = 900;
    function tick(timestamp){
      if(start === null) start = timestamp;
      var progress = clamp((timestamp - start) / duration, 0, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      el.textContent = (target * eased).toFixed(decimals) + suffix;
      if(progress < 1){
        window.requestAnimationFrame(tick);
      } else {
        el.textContent = target.toFixed(decimals) + suffix;
      }
    }
    window.requestAnimationFrame(tick);
  }

  roots.forEach(function(root){
    var stagedGroups = root.querySelectorAll('.nf-home__hero-copy, .nf-home__section-head, .nf-home__sample-copy, .nf-home__studio > div:first-child, .nf-home__reviews-score');
    var stagedItems = [];
    stagedGroups.forEach(function(group){
      Array.prototype.slice.call(group.children).forEach(function(child, index){
        child.classList.add('nf-polish-reveal');
        child.style.setProperty('--nf-reveal-delay', (index * 80) + 'ms');
        stagedItems.push(child);
      });
    });

    root.querySelectorAll('.nf-home__category').forEach(function(card, index){
      card.style.setProperty('--nf-reveal-delay', (index * 70) + 'ms');
    });

    root.querySelectorAll('.nf-home__review-grid article').forEach(function(card, index){
      card.classList.add('nf-polish-reveal');
      card.style.setProperty('--nf-reveal-delay', (index * 80) + 'ms');
      stagedItems.push(card);
    });

    if(reduceMotion){
      stagedItems.forEach(function(item){ item.classList.add('is-visible'); });
      root.querySelectorAll('[data-nf-count-to]').forEach(animateNumber);
      return;
    }

    if('IntersectionObserver' in window){
      var revealObserver = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if(!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        });
      }, { threshold: .16, rootMargin: '0px 0px -8% 0px' });
      stagedItems.forEach(function(item){ revealObserver.observe(item); });

      var numberObserver = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if(!entry.isIntersecting) return;
          animateNumber(entry.target);
          numberObserver.unobserve(entry.target);
        });
      }, { threshold: .35 });
      root.querySelectorAll('[data-nf-count-to]').forEach(function(number){
        numberObserver.observe(number);
      });
    } else {
      stagedItems.forEach(function(item){ item.classList.add('is-visible'); });
      root.querySelectorAll('[data-nf-count-to]').forEach(animateNumber);
    }

    var palette = root.querySelector('[data-nf-home-palette]');
    var backLayer = palette && palette.querySelector('[data-nf-home-parallax-layer="back"]');
    var frontItems = palette && palette.querySelectorAll('.nf-home__palette-stage > .nf-home__eyebrow, .nf-home__palette-stage > h3, .nf-home__palette-stage > p:not(.nf-home__eyebrow)');
    var ticking = false;

    function updateParallax(){
      ticking = false;
      if(!palette || !backLayer) return;
      var rect = palette.getBoundingClientRect();
      if(rect.bottom < 0 || rect.top > window.innerHeight) return;
      var centerOffset = rect.top + rect.height / 2 - window.innerHeight / 2;
      var back = clamp(centerOffset * -0.10, -32, 32);
      var front = clamp(centerOffset * 0.045, -14, 14);
      backLayer.style.setProperty('--nf-parallax-back', back.toFixed(2) + 'px');
      if(frontItems){
        frontItems.forEach(function(item){
          item.style.setProperty('--nf-parallax-front', front.toFixed(2) + 'px');
        });
      }
    }

    function requestParallax(){
      if(ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateParallax);
    }

    updateParallax();
    window.addEventListener('scroll', requestParallax, { passive: true });
    window.addEventListener('resize', requestParallax);
  });
})();
